import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
  avatarUrl?: string;
}

interface Workspace {
  id: string;
  name: string;
  slug: string;
  role?: string;
}

interface AuthState {
  user: User | null;
  workspace: Workspace | null;
  token: string | null;
  setAuth: (user: User | null, workspace: Workspace | null, token: string | null) => void;
  setWorkspace: (workspace: Workspace) => void;
  logout: () => void;
  _hasHydrated: boolean;
  setHasHydrated: (state: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      workspace: null,
      token: null,
      _hasHydrated: false,
      setAuth: (user, workspace, token) => set({ user, workspace, token }),
      setWorkspace: (workspace) => set({ workspace }),
      logout: () => set({ user: null, workspace: null, token: null }),
      setHasHydrated: (state) => set({ _hasHydrated: state }),
    }),
    {
      name: 'vizion-auth',
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);

interface Connection {
  id: string;
  name: string;
  type: string;
  host: string;
  port: number;
  database: string;
  status: string;
}

interface AppState {
  connections: Connection[];
  activeConnection: Connection | null;
  setConnections: (connections: Connection[]) => void;
  setActiveConnection: (connection: Connection | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  connections: [],
  activeConnection: null,
  setConnections: (connections) => set({ connections }),
  setActiveConnection: (connection) => set({ activeConnection: connection }),
}));
